import { createContext } from 'react';
import { Product, ProductContextType } from './types';

export const ProductContext = createContext<ProductContextType>({
  product: {} as unknown as Product,
});
